import * as React from "react";
import ListItemHybrid from "./ListItemHybrid";
import type { TypeListItemProps } from "./ListItemTypes";

/**
 * ListItem automatically routes between the Tailwind implementation (preferred)
 * and the styled-components implementation (for consumers using system props
 * or a styled() extension).
 */
const ListItem = React.forwardRef<HTMLLIElement, TypeListItemProps>(
  (props, ref) => <ListItemHybrid {...props} ref={ref} />
);

ListItem.displayName = "ListItem";

export default ListItem;
